import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import OtpInput from "react-otp-input";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";




/**
 * PanCardPage component provides a form for users to add their PAN card number.
 * Handles validation, navigation, and submission logic for PAN details.
 */
const PanCardPage = ({ login = null }) => {

  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    panDigits: Yup.string()
      .matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Invalid PAN Card Number")
      .required("PAN Card Number is required"),
  });

  const handleEditClick = () => {
    // Navigate back to the previous page
    navigate(-1);
  };
  const formik = useFormik({
    initialValues: {
      panDigits: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true); // Set loading state to true

        // Save PAN details
        const user_Id = userId; // static user_id value
        const requestBody = {
          pan_number: values.panDigits,
          user_id: user_Id,
          name: '',
        };

        navigate(`/${redirectUrl}/reconfirm-pan-details/${userId}`, {
          state: {
            // bankdetails: apiResponseData?.original?.data?.data,
            uservalue: requestBody,
            userId: userId,
          },
        });


      } catch (error) {
        alert("Error while processing PAN Card details");
      } finally {
        setLoading(false); // Ensure loading state is set to false in case of an error
      }
    },
  });
  return (
    <>
      <div className="container pancard_page mt-5">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-5">
            <div className="text-center mb-3">
              <img
                width="50%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/PAN-Upload-min.png")}
              />
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-7">
            <h1 className="mb-5">Add PAN Card</h1>
            <p className="mb-10 grey-text">Enter your PAN Card Number below.</p>
            <h6>PAN Card</h6>
            <form onSubmit={formik.handleSubmit}>
              {/* Hidden input for user_id */}
              <input type="hidden" name="user_id" value="5" />
              <div className="pandigit">
                <OtpInput
                  value={formik.values.panDigits}
                  onChange={(panDigits) =>
                    formik.setFieldValue("panDigits", panDigits)
                  }
                  numInputs={10}
                  // renderSeparator={<span>-</span>}
                  renderInput={(props) => (
                    <input
                      {...props}
                      style={{
                        textAlign: "center" /* Add any other styles you want to unset or override */,
                        textTransform: "uppercase"

                      }}
                    />
                  )}
                />
              </div>

              <div className="error-messages">
                {formik.touched.panDigits && formik.errors.panDigits && (
                  <p className="text-danger">{formik.errors.panDigits}</p>
                )}
              </div>
              <div className="btns cn-btn mt-15 d-flex">
                <button
                  type="button"
                  className="btn bgdark-blue text-white"
                  onClick={handleEditClick}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="btn red-btn text-white"
                  style={{
                    backgroundColor: loading ? "#999" : "red-btn text-white",
                    color: "white",
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Next"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};

export default PanCardPage;
